import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estTime'
})
export class EstTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: Date | string | number | null | undefined): string {
    if (!value) {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    const formatted = this.datePipe.transform(date, 'hh:mma', undefined, 'America/New_York');
    return formatted ? `${formatted.toLowerCase()} EST` : '';
  }
}
